module.exports = __webpack_public_path__ + "static/media/zahid.7af089a0.png";